export default __webpack_public_path__ + "static/media/untitled.26ce170d.jpg";